






























































import Vue from "vue";
import Component from "vue-class-component";
import { AppGroupService as appGroupApi } from "@/common/api/services/AppGroupService";
import { formatImageUrl } from "@/common/utils";
import qNotify from "@/common/qNotify";
@Component({
  name: "AlbumIndex",
  components: {},
})
export default class AlbumIndex extends Vue {
  list = [];
  params: any = {
    groupId: null,
    page: 1,
  };
  mounted() {
    this.params.groupId = Number.parseInt(
      this.$router.currentRoute.params.groupId
    );
  }

  async getList($state) {
    try {
      const result = await appGroupApi.userGroupAlbums(this.params);

      if (result.data.list.length > 0) {
        this.params.page += 1;
        this.list = [...this.list, ...result.data.list];
        $state.loaded();
      } else {
        $state.complete();
      }
    } catch (error) {
      $state.complete();
      if (error.status === 404) {
        return this.$router.push({
          name: "group.notFound",
          params: { groupId: this.params.id },
        });
      } else {
        qNotify.error({
          text: error.body.message,
        });
      }
    }
  }

  imagesList(images: []) {
    return images.slice(0, 3);
  }

  getImagePath(image) {
    return formatImageUrl(image.name, "400x400");
  }
}
